"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _ObjectTypeIdMappings = _interopRequireDefault(require("./ObjectTypeIdMappings"));

var API_URL = 'crm-record-cards/v2/views';

function fetch(_ref) {
  var objectType = _ref.objectType,
      subjectId = _ref.subjectId;
  var numberSubject = parseInt(subjectId, 10);
  return ImmutableAPI.get(API_URL + "/" + _ObjectTypeIdMappings.default[objectType] + "/" + numberSubject + "/user-specific?location=LEFT_SIDEBAR");
}